
<div class="js-cart-login ws-vue-login-hijack">
  <a
    v-if="!loggedIn"
    v-cloak
    :href="loginUrlWithParam"
    class="account-menu__account account-menu__account--login"
    :class="{ hidden: initialPlacement }"
  >
    <img :src="loginIcon" alt="in" />
    {{ $t('login.hf_template.to_login') }}</a>
  <span
    v-else-if="cart.initial"
    class="account-menu__account account-menu__account--login"
  >
    <q-spinner class="q-mr-sm" />
  </span>
  <span v-else class="account-menu__account account-menu__account--logged">
    <a class="account-menu__logout-icon" :href="logoutUrl">
      <img :src="logoutIcon" alt="out" />
    </a>
    <span class="account-menu__account__name-wrapper">
      <span class="account-menu__account__name">
        {{ cart.user.login }}
      </span>
      <span class="account-menu__account__logout">
        {{ $t('login.hf_template.to_logout') }}
      </span>
    </span>
  </span>
</div>
